import { resolveMeterColor } from "@next-platform/client-common-core";
import type { MeterColorKey, MeterColorTheme } from "@next-platform/packages-ts-types";
import { useTheme as useNextTheme } from "next-themes";

import { Theme } from "@/constants/theme";

/** The theme the palette resolves under: `resolvedTheme` (not the selected `system` value), default light. */
export function useMeterColorTheme(): MeterColorTheme {
  const { resolvedTheme } = useNextTheme();
  return resolvedTheme === Theme.DARK ? "dark" : "light";
}

/** Resolved hex for a meter color palette key under the active theme (`resolvedTheme`, default light). */
export default function useMeterColor(color?: MeterColorKey): string | undefined {
  return resolveMeterColor({ color, theme: useMeterColorTheme() });
}
